'use client';

import Button from '@/components/base/button/button';
import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import { useBreakpointUp } from '@/hooks/use-theme';
import { usePathname, useRouter } from '@/navigation';
import { ArrowLeft } from '@phosphor-icons/react/dist/ssr';
import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';
import { type MouseEventHandler, type ReactNode, useMemo } from 'react';

type Props = {
  href?: string;
  text?: ReactNode;
};

const BackButton = ({ href, text }: Props) => {
  const t = useTranslations('common');
  const isDesktop = useBreakpointUp('s');
  const pathname = usePathname();
  //NOT SHOWING BUTTON ON 3 STEP
  const isThirdStep = pathname.endsWith('payment-shipping');
  const buttonText = text ?? t('back');

  const router = useRouter();

  const props = useMemo<
    { isLink: true; href: string } | { onClick: MouseEventHandler }
  >(
    () => (href ? { isLink: true, href } : { onClick: () => router.back() }),
    [href, router],
  );

  return (
    <Button
      variant="tertiary-no-frame"
      className={clsx(isThirdStep && 'invisible', 'mr-auto')}
      size={isDesktop ? 'large' : 'default'}
      aria-label={t('back')}
      {...props}
    >
      <PhosphorIcon Icon={ArrowLeft} className="icon-m s:icon-l m:hidden" />
      <div className="m:flex hidden gap-xxs font-semibold text-strong">
        <PhosphorIcon Icon={ArrowLeft} variant="bold" className="icon-m" />
        {buttonText}
      </div>
    </Button>
  );
};

export default BackButton;
